import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Col, Row } from 'antd';

import { routeFileSelector } from '../../../../../../utilz/i18n';
import FilterCard from '../../../../../components/Cards/FilterCard';
import FormCheckBox from '../../../../../components/Inputs/FormCheckBox';
import SecondaryLabel from '../../../../../components/Labels/SecondaryLabel';
import ProvidersListCard from './ProvidersListCard';

const SpotBidProviderCard = ({ providers, distributionName, handleProvidersChange, actualIndex }) => {
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  const providerSelectedAll = useMemo(() => providers?.length > 0 && providers.every((p) => p.selected), [providers]);

  const handleAllProvidersCheckbox = (e) => {
    const { checked } = e.target;
    const updated = providers.map((p) => ({ ...p, selected: checked }));
    handleProvidersChange(updated, actualIndex);
  };

  const handleProviderClick = (e, index) => {
    const { checked } = e.target;
    const updated = providers.map((p, i) => (i === index ? { ...p, selected: checked } : p));
    handleProvidersChange(updated, actualIndex);
  };

  return (
    <FilterCard
      title={
        <Row>
          <Col>
            <FormCheckBox
              checkBoxClass="normal-checkbox"
              label={
                <span>
                  <SecondaryLabel className="mr-3">{`${t('translation:default.fields.distributor')}`}</SecondaryLabel>
                  <SecondaryLabel className="f-14 fw-600">{distributionName}</SecondaryLabel>
                </span>
              }
              className="m-0"
              onChange={handleAllProvidersCheckbox}
              checked={providerSelectedAll}
            />
          </Col>
        </Row>
      }
      className="mb-16 overflow-hidden d-flex flex-direction-column"
      showBorder
    >
      <div className="flex-1">
        {providers.map(({ key, ...rest }, idx) => (
          <ProvidersListCard
            providerDetails={rest}
            // biome-ignore lint/suspicious/noArrayIndexKey: TODO: fix
            key={idx}
            index={idx}
            selected={Boolean(providers?.[idx]?.selected)}
            handleProviderClick={handleProviderClick}
            isLastItem={providers.length === idx + 1}
          />
        ))}
      </div>
    </FilterCard>
  );
};

export default SpotBidProviderCard;
